import React, { useEffect } from 'react';
import { Pressable } from 'react-native';
import { Box, Inline } from '@styleseat/ui';
import { BrandColor, toRGBA } from '@styleseat/brand';
import { BodyText, Stack } from '../../../ui';
import { BasicCameraIcon } from '../../../ui/Icons';
import ProProfileLazyImage from '../../../ui/LazyImage/ProProfileLazyImage';
import { ProfileGalleryImage } from '../../../../api/Providers/GalleryImages';
import { EmptyableImage } from './types';
import formatProfilePhoto from '../../../../modules/formatters/formatProfilePhoto';
import analytics from '../../../../modules/analytics';

type ProfileMobileImageGridProps = {
  onImageClick?: (image: EmptyableImage, index: number) => void;
  galleryImages: Array<ProfileGalleryImage>;
  onSeeAllPhotosClick: () => void;
  totalImages?: number;
  providerId?: number;
};

export const ProfileMobileImageGrid: React.FCWithChildren<
ProfileMobileImageGridProps
> = ({
  onImageClick,
  galleryImages,
  onSeeAllPhotosClick,
  totalImages,
  providerId,
}) => {
  useEffect(() => {
    analytics.track('client_revamp_proprofile_mobile_gallery_view', {
      profile_type: 'provider',
      cover_image_click: false,
    });
  }, []);
  return (
    <Box
      testID="revamp_mobile_gallery"
    >
      {(totalImages > 1) && (
        <Inline
          testID="revamp_mobile_gallery_more_than_one_image"
          style={{
            scrollSnapType: 'x mandatory',
            overflowX: 'scroll',
          } as any}
          space={8}
          paddingX={24}
        >
          {galleryImages.map((image, index) => (
            <Box
              testID={`revamp_mobile_gallery_more_than_one_image_${index}`}
              width={232}
              height={232}
              color={BrandColor.LightGrey}
              style={{
                scrollSnapAlign: 'center',
                scrollSnapStop: 'always',
                display: 'flex',
              } as any}
              borderRadius={4}
              key={`revamp_mobile_gallery_more_than_one_image_${index + 10}_providerId_${providerId}`}
            >
              <ProProfileLazyImage
                inNewMobileBreakpoint
                source={formatProfilePhoto(image.url, '_300x300.jpg')}
                fallback={image.url}
                description={`galleryImage-${index}`}
                width={232}
                height={232}
                dataSet={{
                  event: `galleryImage-${index}`,
                }}
                borderRadius={4}
                onPress={() => onImageClick(image, index)}
              />
            </Box>
          ))}
          <Pressable
            testID="revmap_mobile_gallery_image_see_all_box"
            onPress={onSeeAllPhotosClick}
          >
            <Box
              width={232}
              height={232}
              color={BrandColor.LightGrey}
              style={{
                scrollSnapAlign: 'center',
                scrollSnapStop: 'always',
                display: 'flex',
              } as any}
              borderRadius={4}
              testID="touchable-image-see-all"
            >
              <Stack
                justifyContent="center"
                alignItems="center"
                flex={1}
                color={toRGBA(BrandColor.FloraLight, 0.45)}
                borderRadius={4}
              >
                <BasicCameraIcon
                  color={BrandColor.Metal}
                  width={24}
                  height={24}
                />
                <Box
                  paddingTop={4}
                >
                  <BodyText color={BrandColor.Metal} weight="bold">See All Photos</BodyText>
                </Box>
              </Stack>
            </Box>
          </Pressable>
        </Inline>
      )}
      {(totalImages === 1) && (
        <Box
          borderRadius={4}
          testID="revamp_single-image-mobile"
          width="100%"
          maxWidth={930}
          style={{
            aspectRatio: '4 / 2',
            height: 'auto',
          }}
          paddingX={24}
        >
          <ProProfileLazyImage
            inNewMobileBreakpoint
            source={formatProfilePhoto(galleryImages[0].url, '_400x300.jpg')}
            fallback={galleryImages[0].url}
            description="galleryImage-0"
            width="100%"
            height="100%"
            dataSet={{
              event: `galleryImage-${0}`,
            }}
            onPress={() => onImageClick(galleryImages[0], 0)}
          />
        </Box>
      )}
    </Box>
  );
};
